import { useMemo } from 'react';
import { useCompany } from '../hooks/company';

import dayjs from 'dayjs';
import { UpdatePasswordModal } from '../pages/UserInfo';

// 擎天柱（占位/系统账号）豁免强制改密码。currentUser.id 为字符串（Long），
// 需转 Number 后比较，与 Layout/SystemConfig 中的判断保持一致。
const PASSWORD_CHECK_EXEMPT_USER_ID = 10000;

export default function PasswordUpdateCheck() {
  const { currentUser } = useCompany();

  const shouldUpdatePassword = useMemo(() => {
    if (Number(currentUser.id) === PASSWORD_CHECK_EXEMPT_USER_ID) {
      return false;
    }
    if (!currentUser.userConfig?.passwordLastUpdatedAt) {
      return true;
    }
    const lastUpdatedAt = dayjs(currentUser.userConfig?.passwordLastUpdatedAt);
    return lastUpdatedAt.isBefore(dayjs().subtract(3, 'month'));
  }, [currentUser.userConfig?.passwordLastUpdatedAt]);

  if (!shouldUpdatePassword) {
    return null;
  }

  return (
    <>
      <UpdatePasswordModal
        open={shouldUpdatePassword}
        tips="您的密码已超过一个月未更新，请及时更新密码"
      />
    </>
  );
}
